import { UNIT_REQUEST, UNITS_SHOW, UNIT_EDIT, UNIT_FAIL } from "../store/config";

const unitInit = {
	isFetching:false,
	list:[],
	edit:{},
	error:null
};

const units = (state=unitInit,action) => {
	switch (action.type){
		case UNIT_REQUEST:
			return {
				...state,
				isFetching:action.isFetching,
				edit:action.edit,
				timestamp:action.timestamp
			};
		case UNITS_SHOW:
			return {
				...state,
				isFetching:action.isFetching,
				list:action.list,
				timestamp:action.timestamp
			};
		case UNIT_EDIT:
			return {
				...state,
				isFetching:action.isFetching,
				edit:action.edit,
				timestamp:action.timestamp
			};
		case UNIT_FAIL:
			return {
				...state,
				isFetching:action.isFetching,
				error:action.error,
				timestamp:action.timestamp
			};
		default:
			return {
				...state
			};
	}
};

export default units;


// WEBPACK FOOTER //
// ./src/reducers/units.js